export default {
  copyright: "{{projectToken}} 2025. Powered by {{projectToken}} DAO",
  termsOfService: "Terms of Service",
}
